import React from 'react';
import { Countdown } from './Countdown';
import { OfferSelector } from './OfferSelector';
export const Pricing = () => {
  return <section id="pricing" className="py-8 sm:py-12 md:py-16 bg-cream" data-id="element-226">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        {/* Offer Header */}
        <div className="text-center mb-4 sm:mb-6" data-id="element-228">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 font-bold px-3 py-1 rounded-full text-xs mb-3 sm:mb-4 animate-pulse" data-id="element-229">
            <span className="w-2 h-2 rounded-full bg-red-600" data-id="element-230"></span> Oferta en
            vivo
          </div>

          <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-231">
            Elegí tu Kit Epilepsia Bajo Control™ 2026
          </h2>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6" data-id="element-232">
            Ambas opciones incluyen los 4 tomos y los 3 bonos completos
          </p>

          <div className="bg-white p-3 sm:p-4 md:p-5 rounded-2xl shadow-sm border border-brand-orange/20 max-w-xl mx-auto mb-4 sm:mb-6" data-id="element-233">
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-234">
              LANZAMIENTO TERMINA EN
            </p>
            <Countdown data-id="element-235" />
            <p className="text-xs sm:text-sm text-brand-orange font-medium mt-2" data-id="element-236">
              +$8.000 DESPUÉS — Y no vuelve a bajar
            </p>

            <div className="mt-3" data-id="element-237">
              <div className="flex justify-between text-xs font-bold text-gray-500 mb-1" data-id="element-238">
                <span data-id="element-239">Cupos restantes</span>
                <span className="text-brand-green" data-id="element-240">68% TOMADOS</span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-241">
                <div className="bg-brand-green h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-242"></div>
              </div>
            </div>
          </div>
        </div>

        <OfferSelector data-id="element-243" />
      </div>
    </section>;
};